import Phaser from 'phaser';
import $ from 'jquery';
import { CST } from '../../CST';

const COLOR_PRIMARY = 0x7c2b7f;
const COLOR_LIGHT = 0x301934;
const COLOR_DARK = 0x7c2b7f;

var User_ID = Math.floor(Math.random() * 9999999 + 1); //Math.random().toString(36).substr(2, 7)
var ageSelected = ['-'];
var nationalitySelected = ['-'];
var ethnicitySelected = ['-'];
var genderSelected = ['Prefer not to say'];
var dementiaSelected = ['-'];

export default class Form extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.FORM);
	}

	preload() {
		// Questionnaire assets — loaded here so they don't block the initial loading screen
		this.load.image('questionnaire-bg', 'assets/Questionnaire/Questionnaire - Background.png');
		this.load.image('questionnaire-popUp', 'assets/Questionnaire/Questionnaire Pop-up.png');
		this.load.image('questionnaire-popUp-2', 'assets/Questionnaire/Questionnaire Pop-up 2.png');
		this.load.image(
			'questionnaire-popUp-3',
			'assets/Questionnaire/Questionnaire Dropdown Pop-up.png',
		);
		this.load.image('color-bar', 'assets/Questionnaire/scale_1.png');
		this.load.image('scale', 'assets/Questionnaire/scale.png');
		this.load.image('agree-btn', 'assets/Questionnaire/agree.png');
		this.load.image('agree-a-lot-btn', 'assets/Questionnaire/agree-a-lot.png');
		this.load.image('unsure-btn', 'assets/Questionnaire/unsure.png');
		this.load.image('disagree-btn', 'assets/Questionnaire/disagree.png');
		this.load.image('disagree-a-lot-btn', 'assets/Questionnaire/disagree_a_lot.png');
		this.load.spritesheet('checkbox-sprite', 'assets/Questionnaire/checkbox_sprite.png', {
			frameWidth: 93.5,
			frameHeight: 96,
		});
		this.load.scenePlugin({
			key: 'rexuiplugin',
			url: 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexuiplugin.min.js',
			sceneKey: 'rexUI',
		});
	}

	create() {
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'questionnaire-bg');
		this.clickSound = this.sound.add('click-sound', {
			volume: 0.5,
		});
		this.popUp = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'questionnaire-popUp-3')
			.setScale(0.78);

		var ageOptions = ['-', '7', '8', '9', '10', '11', '12'];
		var nationalityOptions = ['-', 'British', 'Northern Irish', 'Irish', 'Other'];
		var ethnicityOptions = [
			'-',
			'Chinese',
			'Irish Traveller',
			'White',
			'Indian',
			'Pakistani',
			'Bangladeshi',
			'Black Caribbean',
			'Black African',
			'Black Other',
			'Mixed ethnic group',
			'Any other ethnic group',
		];
		var genderOptions = ['Prefer not to say', 'Boy', 'Girl', 'Other'];
		var dementiaOptions = ['-', 'Yes', 'No'];

		var ageDropDown = CreateDropDownList(
			this,
			this.cameras.main.width / 2 - 415,
			this.cameras.main.height / 2 - 255,
			ageOptions,
		).layout();
		var nationalityDropDown = CreateDropDownList(
			this,
			this.cameras.main.width / 2 - 330,
			this.cameras.main.height / 2 + 120,
			nationalityOptions,
		).layout();
		var ethnicityDropDown = CreateDropDownList(
			this,
			this.cameras.main.width / 2 + 300,
			this.cameras.main.height / 2 - 100,
			ethnicityOptions,
		).layout();
		var genderDropDown = CreateDropDownList(
			this,
			this.cameras.main.width / 2 - 310,
			this.cameras.main.height / 2 + 5,
			genderOptions,
		).layout();
		var dementiaDropDown = CreateDropDownList(
			this,
			this.cameras.main.width / 2 + 270,
			this.cameras.main.height / 2 + 245,
			dementiaOptions,
		).layout();

		this.nextBtn = this.add
			.image(this.cameras.main.width / 2 + 690, this.cameras.main.height / 2 + 350, 'next-btn')
			.setInteractive({
				useHandCursor: true,
			})
			.on('pointerdown', () => {
				if (
					ageSelected[0] === '-' ||
					ethnicitySelected[0] === '-' ||
					dementiaSelected[0] === '-' ||
					nationalitySelected[0] === '-'
				) {
					let popUp = this.add
						.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'error')
						.setScale(0.7);
					setTimeout(() => {
						popUp.destroy();
					}, 1000);
				} else {
					this.clickSound.play();
					sendUserDataToDatabase();
					/*this.scene.start(CST.SCENES.INTRO, {
                    User_ID: User_ID
                })*/
					this.scene.start(CST.SCENES.UISCENE, {
						User_ID: User_ID,
					});
				}
			})
			.setScale(0.5);
	}
}

function sendUserDataToDatabase() {
	var userCorrectAnswer = {
		User_ID: User_ID,
		age: ageSelected[0],
		nationality: nationalitySelected[0],
		ethnicity: ethnicitySelected[0],
		gender: genderSelected[0],
		dementia: dementiaSelected[0],
	};

	//Sending JSON string to PHP file
	$.ajax({
		type: 'POST',
		url: 'website/post-form-to-ddbb.php',
		dataType: 'JSON',
		data: userCorrectAnswer,
	}).responseJSON;
}

function CreateDropDownList(scene, x, y, options) {
	var maxTextSize = GetMaxTextObjectSize(scene, options);

	var label = scene.rexUI.add
		.label({
			x: x,
			y: y,

			background: scene.rexUI.add.roundRectangle(0, 0, 2, 2, 0, COLOR_PRIMARY),

			icon: scene.rexUI.add.roundRectangle(0, 0, 20, 20, 10, COLOR_LIGHT),

			text: CreateTextObject(scene, '').setFixedSize(maxTextSize.width, maxTextSize.height),

			// action:

			space: {
				left: 10,
				right: 10,
				top: 10,
				bottom: 10,
				icon: 10,
			},
		})
		.setData('value', '');

	label.data.events.on('changedata-value', function (parent, value, previousValue) {
		label.text = value;
	});
	if (options[0]) {
		label.setData('value', options[0]);
	}

	var menu;
	scene.rexUI.add.click(label).on('click', function () {
		if (!menu) {
			var menuX = label.getElement('text').getTopLeft().x,
				menuY = label.bottom;
			menu = CreatePopupList(scene, menuX, menuY, options, function (button) {
				label.setData('value', button.text);
				menu.collapse();
				if (menu.items.length === 3) {
					if (dementiaSelected.lenght === 0) {
						dementiaSelected.push(label.text);
					} else {
						dementiaSelected.splice(0, 1, label.text);
					}
				} else if (menu.items.length === 7) {
					if (ageSelected.lenght === 0) {
						ageSelected.push(label.text);
					} else {
						ageSelected.splice(0, 1, label.text);
					}
				} else if (menu.items.length === 4) {
					if (genderSelected.lenght === 0) {
						genderSelected.push(label.text);
					} else {
						genderSelected.splice(0, 1, label.text);
					}
				} else if (menu.items.length === 5) {
					if (nationalitySelected.lenght === 0) {
						nationalitySelected.push(label.text);
					} else {
						nationalitySelected.splice(0, 1, label.text);
					}
				} else {
					if (ethnicitySelected.lenght === 0) {
						ethnicitySelected.push(label.text);
					} else {
						ethnicitySelected.splice(0, 1, label.text);
					}
				}
				menu = undefined;
			});
		} else {
			menu.collapse();
			menu = undefined;
		}
	});
	return label;
}

function CreatePopupList(scene, x, y, options, onClick) {
	var items = options.map(function (option) {
		return {
			label: option,
		};
	});
	var menu = scene.rexUI.add.menu({
		x: x,
		y: y,
		orientation: 'y',

		items: items,
		createButtonCallback: function (item, i, options) {
			return scene.rexUI.add.label({
				background: scene.rexUI.add.roundRectangle(0, 0, 2, 2, 0, COLOR_DARK),

				text: CreateTextObject(scene, item.label),

				space: {
					left: 10,
					right: 10,
					top: 10,
					bottom: 10,
					icon: 10,
				},
			});
		},

		// easeIn: 500,
		easeIn: {
			duration: 500,
			orientation: 'y',
		},

		// easeOut: 100,
		easeOut: {
			duration: 100,
			orientation: 'y',
		},

		// expandEvent: 'button.over'
	});

	menu
		.on('button.over', function (button) {
			button.getElement('background').setStrokeStyle(1, 0xffffff);
		})
		.on('button.out', function (button) {
			button.getElement('background').setStrokeStyle();
		})
		.on('button.click', function (button) {
			onClick(button);
		});

	return menu;
}

function GetMaxTextObjectSize(scene, contentArray) {
	var textObject = CreateTextObject(scene, '');
	var width = 0,
		height = 0;
	for (var i = 0, cnt = contentArray.length; i < cnt; i++) {
		textObject.text = contentArray[i];
		width = Math.max(textObject.width, width);
		height = Math.max(textObject.height, height);
	}
	textObject.destroy();

	return {
		width: width,
		height: height,
	};
}

function CreateTextObject(scene, text) {
	var textObject = scene.add.text(0, 0, text, {
		fontSize: '20px',
		fontStyle: 'bold',
	});
	return textObject;
}
